import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
import { SBLSelector } from "../../Sites/SBLSelector";

export class QualityCard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Station"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-3"></div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Name *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.name || ""}
                        onChange={e =>
                          this.props.updateValue("name", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Description *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.description || ""}
                        onChange={e =>
                          this.props.updateValue("description", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>

                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Current Status</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.operatingStatus || ""}
                        options={this.props.stationStatusList}
                        onChange={e =>
                          this.props.updateValue("operatingStatus", e.value)
                        }
                        required={true}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">
                        Do you want to set a location for this tool?
                      </label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.specificAddressRequired}
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false }
                        ]}
                        onChange={e => {
                          this.props.updateValue(
                            "specificAddressRequired",
                            e.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  {this.props.editedObject.specificAddressRequired === true && (
                    <div className="ui-g-12">
                      <SBLSelector
                        type={"GLOBAL"}
                        updateState={this.props.updateValue}
                        siteId={this.props.editedObject.siteId}
                        buildingId={this.props.editedObject.buildingId}
                        locationId={this.props.editedObject.locationId}
                        showAddress={false}
                      />
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Quality/UI/QualityCard.js